export default "__VITE_ASSET__CmLatIrv__"